import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { darkModeAware, withStyles } from '@glu/theming';
import { CaretDownIcon } from '@glu/icons-react';
import styles from './SelectBase.styles';

let uniqueId = 0;

const SelectBase = ({
  children,
  className,
  classes,
  dark: _dark,
  firstOption,
  htmlId,
  name,
  onChange,
  theme: _theme,
  /** These shouldn't be passed in as a prop to select. underscore indicates not used */
  value,
  warning,
  ...rest
}) => {
  // eslint-disable-next-line no-plusplus
  const id = useMemo(() => htmlId || `input-${uniqueId++}`, [htmlId]);
  return (
    <div className={`${classes.root} ${className}`}>
      <select
        id={id}
        className={`${classes.select}`}
        name={name}
        onChange={onChange}
        value={value !== undefined && value !== null ? value : ''}
        {...rest}
      >
        {firstOption}
        {children}
      </select>
      <CaretDownIcon noIconWrapper focusable={false} />
      <span className={`${classes.caret}`} />
    </div>
  );
};

SelectBase.propTypes = {

  children: PropTypes.node.isRequired,

  /** ClassName to use for the root element of this component, a wrapper div */
  className: PropTypes.string,

  /** Classes for JSS styling */
  classes: PropTypes.objectOf(PropTypes.string).isRequired,

  /** True if the select should be in dark mode which styles it for dark colored forms */
  dark: PropTypes.bool,

  /** Content for the first option, including the <option> tag set null/false to not use */
  firstOption: PropTypes.node,

  /** Html id to use for the select */
  htmlId: PropTypes.string,

  /** Name to use for the select */
  name: PropTypes.string,

  /** called whenever onChange happens on the select */
  onChange: PropTypes.func.isRequired,

  /** JSS theme */
  theme: PropTypes.shape({}).isRequired,

  /** Value of currently selected option */
  value: PropTypes.string,

  /** Use warning styles for error if true */
  warning: PropTypes.bool
};

SelectBase.defaultProps = {
  className: '',
  dark: false,
  // eslint-disable-next-line jsx-a11y/control-has-associated-label
  firstOption: <option value="" />,
  htmlId: '',
  name: undefined,
  // eslint-disable-line jsx-a11y/control-has-associated-label
  value: undefined,
  warning: false
};

export { SelectBase as BareSelect };
export default darkModeAware(withStyles(styles)(SelectBase));
